import React from 'react';
import { useTranslation } from 'react-i18next';
import { OccupancySelector } from '@livable/saas-react-components';
import { Typography, Grid, TextField, Alert } from '@mui/material';
import useStyles from './styles';
export default function OccupancyTabContent(_ref) {
  let handleOccupancyChange = _ref.handleOccupancyChange,
    _ref$isUnoccupiedUnit = _ref.isUnoccupiedUnit,
    isUnoccupiedUnit = _ref$isUnoccupiedUnit === void 0 ? false : _ref$isUnoccupiedUnit,
    occupancy = _ref.occupancy;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('residencies_page.keep_occupancy')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('residencies_page.occupancy_text'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(OccupancySelector, {
    currentValue: occupancy,
    fieldName: "occupancy",
    handleChange: (e, v) => handleOccupancyChange(v),
    startsWithZero: true
  })), occupancy === 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "warning"
  }, "* ", t('residencies_page.unoccupied_unit'))), isUnoccupiedUnit && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Roomates (optional)")), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Name Surname",
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Email address",
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Name Surname",
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Email address",
    variant: "outlined",
    fullWidth: true
  }))))));
}